module.exports = __webpack_public_path__ + "img/taocan-home-img.9083a415.png";